export default "__VITE_ASSET__CdiUSqnw__"